import React from 'react';
import firebase from 'firebase/app';
import 'firebase/firestore';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';



var tipounidade=[];
export default function  ParadaMap (props) {
const [statelista, setalista]=React.useState([]);
const [statecampi,setstatecampi]=React.useState('');
const [unidadet,setaunidadet]=React.useState([{
}]);
var listaunidadest=[];


    React.useEffect (()=>{
//setaunidadet(props.unidadet);
setstatecampi(props.campi);
       // console.log ("valor campi valendo nesno", unidadet);
        //console.log ("valor campi valendo nesno", statecampi);
       // pegalista();
               
        
            firebase.firestore().collection("unidadetransporte").where('status', '==', true).where('campi', '==', statecampi)
             .get()
             .then(function(querySnapshot) {
                 listaunidadest=[];
                 querySnapshot.forEach(function(doc) {
                     listaunidadest.push({id: doc.id, label: doc.data().nomeunidadetransporte});
                 })
                 
                    setalista(listaunidadest)
                 

                 
                 console.log("lista unidade transporte: ", listaunidadest);
             })
             .catch(function(error) {
                 console.log("erro carregar as unidades de transporte: ", error);
                 alert('Não foi Possível carregar as unidades de transporte.');
             })
     
             

             if (props.unidadet!='') {
                pegaunidadetransporte();
            }

             async function pegaunidadetransporte(cod){
    
                var campis='';
               console.log("valor cod", cod);
                var ut = firebase.firestore().collection("unidadetransporte").doc(props.unidadet);
                 await ut.get()
                  .then((doc) => {       
                    if (doc.exists) {
                      tipounidade=[];
                        tipounidade.push({id: doc.id, label: doc.data().nomeunidadetransporte});
                        //campis = doc.data().campi;
                      }
                      setaunidadet(tipounidade);
                      props.setaunidadetransporte(tipounidade);
                      console.log("saporra ", tipounidade);
                     
                  })
                  .catch(function(error) {
                      console.log("Erro ao carregar (unidades transporte): ", error);
                  });
              }
    

        
            },[0])


         

  
         
        
        
        

        

   

    const handleuniade=(event, value)=>(
        setaunidadet([value]),
        props.setaunidadetransporte([value]),
        console.log("target ", value)
    )




console.log("target ", props.unidadet);
console.log("target ", statelista);
//var temp= props.unidadet[0].label;
//onsole.log("target3 ", temp);

    return(
        <Autocomplete onChange={handleuniade}
                   
        
                    id="combounidadetchef"
                    options={statelista}
                    disabled={props.disabled}
                    getOptionLabel={(option) => option.label}
                    value={unidadet[0]}
                   // defaultValue={props.unidadet[0]}
                   getOptionSelected={(option,temp) => option.id==temp.id}
                   renderInput={(params) => <TextField {...params}  required={props.requer}  label="Unidade de Transporte" variant="outlined" />}
                />
                
                

                
                
)
}

//